import { SelectedExcursions } from './excursion.model';
import { InviteeStatus } from './registrants.model';

export enum ChairmanExtensionGuestsConfiguration {
  alone = 'alone',
  sameWithMainEvent = 'sameWithMainEvent',
  differentFromMain = 'differentFromMain',
}

export enum RegistrantChairmanExtensionKeys {
  inviteeStatus = 'inviteeStatus',
  guestConfiguration = 'guestConfiguration',
  numberOfGuests = 'numberOfGuests',
  selectedExcursions = 'selectedExcursions',
}
export class RegistrantChairmanExtension {
  [RegistrantChairmanExtensionKeys.inviteeStatus]?: InviteeStatus = InviteeStatus.initial;
  [RegistrantChairmanExtensionKeys.guestConfiguration]?: ChairmanExtensionGuestsConfiguration;
  [RegistrantChairmanExtensionKeys.numberOfGuests]?: number;
  [RegistrantChairmanExtensionKeys.selectedExcursions]?: SelectedExcursions;
}
